<template>
  <div class="VIPclass">
    <div class="logins">
      <div class="banner_main_right">
        <div v-if="!userInfo" class="login">
            <div v-if="showError" class="error-message">
            {{ errorMessage }}
          </div>
          <div class="line"></div>
          <p>密码登录</p>

          <div class="contentTop">
            <el-form ref="passwordLogin" :model="ruleForma" :rules="rules">
              <el-form-item prop="username">
                <el-input v-model.trim="ruleForma.username" placeholder="请输入账号">
                  <template #prefix>
                    <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x45.png" alt="icon"
                      style="width: 14px; height: 14px; margin-right: 8px" />
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model.trim="ruleForma.password" placeholder="请输入密码" show-password>
                  <template #prefix>
                    <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x54.png" alt="icon"
                      style="width: 14px; height: 14px; margin-right: 8px" />
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <!-- 选择框自动登录忘记密码 -->
            <div class="contentTops">
              <div class="contentTopsLeft">
                <label class="custom-checkbox">
                  <input type="checkbox">
                  <span class="checkmark"></span>
                </label>
                <p>自动登录</p>
              </div>
            </div>
          </div>
          <div @click="submit" class="contentTopBtn">立即登录</div>
        </div>
        <div class="welcome-page" v-else>
           <p class="welcome-text">Hi，欢迎来到<br>{{ infoDomain.name }}学习平台</p>
    <div class="avatar-wrapper">
      <img class="avatar" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x55.png" alt="avatar" />
    </div>
    <button class="btn study-btn" style="font-family: DingTalk JinBuTi, DingTalk JinBuTi;font-size: 16px;"  @click="goNext('/all/mycurriculum')">去学习</button>
    <button class="btn logout-btn" @click="logout">退出登录</button>
        </div>
      </div>
    </div>
    <el-carousel height="410px" class="swImg" arrow="never">
      <el-carousel-item v-for="(item, index) in imgList" :key="index" class="pointer">
        <img style="height: 100%" :src="item.img" @click="nav(item)" />
      </el-carousel-item>
    </el-carousel>
    <div class="s_r">
      <div class="z_l">
        <div></div>在线学习
      </div>
      <div class="llll"></div>
    </div>
    <!-- 套餐列表 -->
    <div class="contentWrap">
      <div v-for="(item, index) in exclusiveClassList" :key="index" class="contentItem" @click="goDetails(item)">
        <div class="imgItem">
          <img :src="item.img" class="img">
        </div>
        <div class="titleItem elp">
          {{ item.tiitle }}
        </div>
        <div class="priceItem">
          <div class="sssk">
            <div v-if="item.curForms" v-for="(i, index) in item.curForms.split(',')" :key="index" class="sss">
              {{ i }}
            </div>

          </div>
          <span class="courseNum">
            <span>共<span style="color:#FF580D;font-family: MiSans-Medium;">{{ item.kechengNum || 0 }}</span>门课</span>
          </span>
        </div>
        <div class="line" />
        <div class="more dis_flex">
          <div style="display: flex;align-items: center;">
            <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x37.png" />
           <span style=" font-family: MiSans-Medium;">{{ item.clicks || 0 }}</span> 人气值
          </div>
          <div class="b elp">

            {{ getTitleAfterDash(item.tiitle) }}
          </div>

        </div>
      </div>
      <div style="margin: 0 auto;" v-if="exclusiveClassList.length == 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>
    <!-- 分页 -->
    <!-- <el-pagination class="pagination" :current-page="pageNum" :page-sizes="[12, 24, 36, 48]" :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" /> -->
  </div>
</template>

<script>
import KindChooseView from '../../components/kindChooseViewkvip.vue'
import { selectPageListToIndex } from '@/api/home'
import { getSurfaceList } from "@/api/home";
import { loginOut } from "@/api/user";

import { getDomain, getInfo } from "@/api/cookies";
import { loginPcUser, SmsMobileCode, loginPcUserSms } from '@/api/login'
export default {
  components: {
    KindChooseView
  },
  data() {
    return {
      exclusiveClassList: [],
      imgList: [],
      pageSize: 12,
      pageNum: 1,
      total: 0,
       showError: false,
      errorMessage: '',
      search: {},
      loading: null,
      userInfo: null,
      ruleForma: {},

      rules: {
        username: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],

        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, message: '密码不能长度小于6个字符', trigger: 'blur' }
        ],

      },
    }
  },
  async beforeDestroy() {
    this.loading.close()
  },
  async created() {
    this.infoDomain = getDomain();
    this.userInfo = await getInfo();

    getSurfaceList(16, undefined, this.infoDomain.entrantsType).then(
      (ress) => {
        if (ress.code == 0) {
          this.imgList = JSON.parse(JSON.stringify(ress.msg));
        }
      }
    );
    this.selectPageListToIndex()
  },
  methods: {
     async logout() {
      // loginOut();
      localStorage.clear();
this.userInfo =null
      window.location.reload();
      // this.$router.replace(`/`);
    },
    submit() {
      this.$refs.passwordLogin.validate(async (valid) => {
        if (valid) {
          loginPcUser(
            this.ruleForma.username,
            this.ruleForma.password,
            'PC端'
          ).then((res) => {
            if (res.code == 0) {
              window.location.reload()
              this.loading = false
            } else {
            this.showError = true;
              this.errorMessage = res.msg;
              // 3 秒后隐藏提示框
              setTimeout(() => {
                this.showError = false;
              }, 3000);
              this.loading = false;
            }
          })
        }
      })
      this.$refs.passwordLogin.disable = true
    },
    getTitleAfterDash(title) {
      if (!title) return '';
      const dashIndex = title.indexOf('-');
      return dashIndex !== -1 ? title.substring(dashIndex + 1).trim() : '';
    },
    /* 筛选 */
    isOk(val) {
      this.pageNum = 1
      this.search = val
      this.selectPageListToIndex()
    },
    /* VIP专属班列表 */
    selectPageListToIndex() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      selectPageListToIndex(
        this.pageSize,
        this.pageNum,
        this.search.school,
        this.search.kind,
        this.search.zyId,
        undefined,
        3, /* productLine 3专属线 */
        this.search.areaId == 1 ? undefined : this.search.areaId,
        this.search.name ? this.search.name : undefined
      ).then((res) => {
        this.exclusiveClassList = res.rows
        this.total = res.total
        this.loading.close()
      }).catch(() => {
        this.loading.close()
      })
    },
    /* 点击进入专属班详情 */
    goDetails(item) {
      let routeUrl = ''
      if (item.productLine === '5') {
        routeUrl = this.$router.resolve({
          path: '/VIP/oneToOneClass',
          query: {
            id: item.id
          }
        })
      } else {
        routeUrl = this.$router.resolve({
          path: '/VIP/VIPClassxq',
          query: {
            id: item.id
          }
        })
      }
      window.open(routeUrl.href, '_blank')
    },
    /* 每页条数 */
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.selectPageListToIndex()
    },
    /* 当前页码 */
    handleCurrentChange(val) {
      this.pageNum = val
      this.selectPageListToIndex()
    }
  }
}
</script>

<style lang="less" scoped>
.VIPclass {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  overflow: hidden;
  position: relative;
  margin-bottom: 60px;

  .contentWrap {
    margin: 20px auto;
    width: 1200px;
    height: auto;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;

    .contentItem {
      width: 282px;
      height: 296px;
      background: #FFFFFF;
      border-radius: 12px 12px 12px 12px;
      cursor: pointer;
      margin: 0 24px 12px 0;
      padding: 12px;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .imgItem {
        width: 100%;
        height: 145px;
        border-radius: 12px 12px 12px 12px;

        .img {
                 width: 100%;

          height: 145px;
          border-radius: 12px 12px 12px 12px;
        }



      }

      .titleItem {

        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        margin-top: 14px;
      }

      .priceItem {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .sssk {
          display: flex;
          align-items: center;

          .sss {
            width: 48px;
            height: 24px;
            background: #EFFAFF;
            border-radius: 4px 4px 4px 4px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #4A8AE8;
            line-height: 24px;
            text-align: center;
            margin: 12px 0;
            margin-right: 12px;

          }
        }


        .courseNum {

          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #A3A9BA;
        }
      }

      .line {
        width: 254px;
        height: 1px;
        border-bottom: none;
        background-image: linear-gradient(to right,
            #e5e5e5 50%,
            transparent 50%);
        background-size: 12px 1px;
        background-position: 0 bottom;
        background-repeat: repeat-x;
      }

      .dis_flex {
        display: flex;
        align-items: center;
        justify-content: space-between;

        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #A3A9BA;
        margin-top: 14px;

        img {
          width: 10px;
          margin-right: 6px;
        }

        .b {
          max-width: 120px;
          height: 24px;
          background: #FEF5E6;
          border-radius: 4px 4px 4px 4px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #C99C6A;
          text-align: center;
          line-height: 24px;
          padding: 0 12px;
        }

      }


    }
  }

  .pagination {
    margin: auto;
  }
}



.s_r {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;

  .z_l {
    display: flex;
    align-items: center;

    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 20px;
    color: #0074ef;

    div {
      width: 15px;
      height: 15px;
      background: linear-gradient(180deg, #0073ff 0%, #0057c9 100%);
      border-radius: 2px 2px 2px 2px;
      margin-right: 8px;
    }
  }

  .llll {
    width: 100%;
    height: 2px;
    background: #0074ef;
    border-radius: 0px 0px 0px 0px;
    margin-top: 12px;
    margin-bottom: 20px;
  }


}

.logins {
  width: 1200px;
  height: 410px;
  position: absolute;
  top: 0;
  display: flex;
  left: 50%;
  transform: translateX(-50%);
  justify-content: flex-end;
  align-items: center;
  z-index: 99;

  .banner_main_right {
    width: 308px;
    height: 327px;
    background: linear-gradient(180deg, #CCE6FF 0%, #FFFFFF 20%);
    border-radius: 12px 12px 12px 12px;
    padding: 20px 20px;

    .login {
      // width: 170px;
      position: relative;
.error-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 128px;
height: 39px;
line-height: 39px;

background: #7F7F7F;
border-radius: 8px 8px 8px 8px; 
    border-radius: 4px;
    z-index: 100;
    animation: fadeInOut 3s ease;
   text-align: center;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #FFFFFF; 
  }

  @keyframes fadeInOut {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

      p {

        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        text-align: center;
        margin-bottom: 22px;
      }

      .contentTopBtn {
        width: 268px;
        height: 43px;
        background: linear-gradient(180deg, #51A3FF 0%, #2080F7 100%);
        box-shadow: 0px 3px 6px 1px rgba(74, 152, 255, 0.59);
        border-radius: 26px 26px 26px 26px;
margin: 0 auto;
        font-family: DingTalk JinBuTi, DingTalk JinBuTi;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        line-height: 43px;
        margin-top: 24px;
        cursor: pointer;

      }


    }
  }

}

.contentTops {
  height: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  top: -10px;
  margin-top: 12px;

  //   左盒子
  .contentTopsLeft {
    // width: 80px;
    // height: 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    // 勾选自动登录输入框
    input {
      width: 12px;
      height: 100%;
      margin-right: 3px;
    }

    // 自动登录
    p {

      font-family: Microsoft YaHei, Microsoft YaHei !important;
      font-weight: 400 !important;
      font-size: 12px !important;
      color: #999999 !important;
      margin-bottom: 0 !important;
      position: relative;
      left: -8px;
      top: -1px;
    }
  }


}

.custom-checkbox {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  font-size: 16px;
  user-select: none;
  top: -6px;
}

/* 隐藏原生复选框 */
.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* 创建自定义复选框 */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 12px;
  width: 12px;
  border-radius: 3px;
  background: #FFFFFF;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #AAA;
}

/* 鼠标悬停时改变背景颜色 */
.custom-checkbox:hover input~.checkmark {
  // background-color: #ccc;
}

/* 选中时的背景颜色 */
.custom-checkbox input:checked~.checkmark {
  background-color: #2196F3;
  /* 选中时的背景颜色 */
  border-radius: 2px 2px 2px 2px;
}

/* 创建选中标记 */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* 显示选中标记 */
.custom-checkbox input:checked~.checkmark:after {
  display: block;
}

/* 样式化选中标记 */
.custom-checkbox .checkmark:after {
  left: 4px;
  top: 0px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/deep/ .el-input {
  width: 100% !important;
  height: 47px !important;
  background: #FFFFFF !important;
  border-radius: 26px 26px 26px 26px !important;
  border: 1px solid #EEEEEE !important;


  .el-input__inner {
    width: 100% !important;
    height: 47px !important;
    background: #FFFFFF !important;
    border-radius: 26px 26px 26px 26px !important;
    border: 0 !important;
    border: 1px solid #EEEEEE !important;
    padding-left: 48px;


  }
}

/deep/ .el-input__prefix {
  display: flex;
  align-items: center;
  margin-left: 18px;
}

.welcome-page {
   
  .welcome-text {
   
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 18px;line-height: 28px;
color: #333333; 
    margin-bottom: 34px;
  }

  .avatar-wrapper {
    width: 85px;
   
    margin: 0 auto;
    margin-bottom: 30px; 
    overflow: hidden; 

    .avatar {
      width: 100%; 
      object-fit: cover;
      display: block;
    }
  }

  .btn {
   width: 268px;
height: 43px;

border-radius: 26px 26px 26px 26px;
    border: none;
   
    cursor: pointer;
    
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #A3A9BA; 
margin: 0 auto;
    margin-bottom: 12px;
    outline: none; 

    &.study-btn {
 
      color: #fff;
    background: linear-gradient( 180deg, #51A3FF 0%, #2080F7 100%);
box-shadow: 0px 3px 6px 1px rgba(74,152,255,0.59);

     
    }

    &.logout-btn {
      background: transparent;
      color: #999; 
      height: 0;

    
    }
  }
}
</style>
